import AppStoreContext from 'contexts/AppStoreContext';
import React from 'react';
import Modal from 'react-modal';
import { ModalState } from 'records/ModalState';

export interface ModalStaticProperties {
  modalClasses?: {
    overlay?: string;
    content?: string;
  };
  modalStyles?: Modal.Styles;
}

interface Props {
  name: string;
}

Modal.setAppElement('#root');

class ModalPortal extends React.Component<Props> {
  static contextType = AppStoreContext;

  handleRequestClose = (): void => {
    this.context.actions.clearAllModals();
  };

  render(): React.ReactNode {
    const { name: portalName } = this.props;
    const { modals } = this.context.state;

    const modalState = modals
      .filter((m: ModalState): boolean => m.portal === portalName)
      .last();

    if (!modalState || !modalState.component) {
      return null;
    }

    const ModalComponent = modalState.component;
    const { modalStyles } = ModalComponent;
    const { content, overlay } = ModalComponent.modalClasses || {};

    return (
      <Modal
        isOpen={modalState.open}
        shouldCloseOnOverlayClick={modalState.shouldCloseOnOverlayClick}
        shouldCloseOnEsc={modalState.shouldCloseOnEsc}
        onRequestClose={this.handleRequestClose}
        style={modalStyles}
        className={content}
        overlayClassName={overlay}
      >
        <ModalComponent {...modalState.props} />
      </Modal>
    );
  }
}

export default ModalPortal;
